import { appConfig } from "src/appConfig";

export const openScosStore = () => {
  window.open(appConfig.scosStoreUrl, "_blank");
};
